export default __webpack_public_path__ + "static/media/icon-replacement.7a359839.svg";